var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [_vm._v("Need financing to support your business growth?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    If you're finding it hard to connect with investors, you're not alone. Access to financing is a major obstacle for African companies. We're building a digital bridge across the financing gap through our Virtual Deal Rooms. Connect with investors who are looking for companies like yours and benefit from the support of our team doing initial eligibility checks.\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openLink },
          },
          [_vm._v("Opportunities for African Businesses")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }